var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.debounceResize),expression:"debounceResize"}],ref:"root"},[_c('div',{ref:"header"},[_vm._t("header")],2),_vm._t("toolbar"),_vm._t("filter"),_c('div',{ref:"resizableDiv"},[_vm._t("table",null,{"bodyHeight":_vm.bodyHeight})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }